import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"

const Logo = ({width, margin}) => {  
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "canborneo-logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 650, quality: 35) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `)

  return (
    <div className='flex-column' style={{width: '100%'}}>
      <div style={{width: `${width}`, textAlign: 'center', margin: `${margin}px`}}>
        <Link to='/'><Img fluid={data.placeholderImage.childImageSharp.fluid} loading='eager' /></Link>
      </div>
    </div>
  )
}

export default Logo
